import axios from "axios";

/*axios.defaults.baseURL = 'http://platforma.loc/api/purchaser/v1'*/
/*axios.defaults.baseURL = 'http://platforma.aumagency.ru/api/purchaser/v1'*/
/*axios.defaults.baseURL = 'https://api.superbaer24.ru/api/purchaser/v1'*/

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const http = axios;

export default http